export { default } from "./CardContactsControl";



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardContactsControl/index.js